import React, {useState, useEffect} from 'react';
import {Table, Input, List, Modal, Checkbox, Button, message, Select, Pagination} from 'antd';
import history from "../../../libs/history";
import styles from './layout.module.less'
import SearchForm,{SearchFormItem} from "../../../components/SearchForm";

import store from "./store";
import projectStore from '../project/store'
import {observer} from 'mobx-react';
import lodash from "lodash";
import {blobToExcel, deepCopy} from "../../../libs";
import http from "libs/http"

// the hook
import { useTranslation } from 'react-i18next';

const {Search} = Input;

export default observer(function () {
  const {t, i18n} = useTranslation()
  const {quoteRecords} = store


  const [selectKeys, setSelectKeys] = useState([])
  const [loading, setLoading] = useState(false)
  const [download, setDownload] = useState(false)
  const [visible, setVisible] = useState(false)
  const [handleId, setHandleId] = useState(0)
  const [poId, setPoId] = useState('')

  useEffect(() => {
    store.fetchQuoteRecords()
    // projectStore.fetchRecords()
    setSelectKeys([])
  }, [])

  const columns = [
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 90,
      render:(value,info)=>{
        return (<><span className={[styles.badge,i18n.language==='en'?styles.autoWidth:''].join(' ')}>
          {t(info?.catalogName?.charAt(0)==='销'?'购':info?.catalogName?.charAt(0))}
        </span>
        {info.goodsInfo.brand}</>)
      }
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 150,
      render:(value,info)=>info.goodsInfo.name,
    },
    {
      title: t('货号'),
      dataIndex: 'factoryCode',
      align: 'center',
      fixed: true,
      width: 100,
      render:(value,info)=>info.goodsInfo.factoryCode,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 50,
      render:(value,info)=>info.goodsInfo.formats,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      align: 'center',
      fixed: true,
      render: (val, info, index) => <div>{info.goodsInfo.price ? info.goodsInfo.price + (info.goodsInfo.type * 1 === 2 ? '元/月' : '元') : '-'}</div>,
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      align: 'center',
      fixed: true,
      render: (val,info) => <div>{info.goodsInfo.duration ? info.goodsInfo.duration + '月' : '-'}</div>,
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      align: 'center',
      fixed: true,
    },
    {
      title: t('合计'),
      dataIndex: 'totalPrice',
      align: 'center',
      fixed: true,
      render: val => <div>{val}元</div>,
    },
    // {
    //   title: t('项目编号'),
    //   dataIndex: 'extra_sn',
    //   width: 90,
    //   align: 'center',
    //   fixed: true,
    //   render:  (val, record, index) => {
    //     let project=projectStore.records.filter(v=>v.id===val*1)
    //     let txt='-'
    //     if(project.length){
    //       txt=project[0]['sn']
    //     }
    //     return <div>{txt}</div>
    //   },
    // },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 70,
      align: 'center',
      fixed: true,
      render: (val,info) => <div>{info.goodsInfo.period ? info.goodsInfo.period : '-'}</div>,
    },
  ]
  // // 全选操作
  // const selectAll = (e) => {
  //   let sel = e.target.checked
  //   let arr = []

  //   if (sel) {
  //     filterQuoteRecords.map((item, index) => {
  //       let ids = []
  //       item.goods.map(v => ids.push(v.id))
  //       arr[index] = ids
  //     })
  //   }
  //   setSelectKeys(arr)
  // }

  // 单选操作
  const onSelectChange = (selectedRowKeys, index) => {
    const keys = deepCopy(selectKeys)
    keys[index] = selectedRowKeys
    setSelectKeys(keys)
  }

  const makeRowClassName = (record, index) => {
    return record.disabled ? styles.disabled : ''
  }

  // 下单操作
  const checkOrder = (record) => {
    setHandleId(record.id)
    store.handleId=record.id
    store.handleRecord=record
    history.push('/user/quote/check')
    // setLoading(true)
    // setVisible(true)
  }

  const handleOk = () => {
    if (!poId) {
      message.warn(t('请输入')+t('PO号')+'！')
      return
    }

    store.checkOrder({quote_id: handleId, po_sn: poId}).then(() => {
      history.push('/user/quote/check')
    }).finally(() => handleCancel)
  }

  const handleCancel = () => {
    setHandleId(0)
    setLoading(false)
    setVisible(false)
  }

  // 合并报价单操作
  const handleMergeQuote = () => {
    let ids = lodash.flattenDeep([].concat(selectKeys)).filter(v => v)

    if (ids.length === 0) {
      message.warn(t('请选择商品')+'！')
      return
    }
    setLoading(true)
    store.mergeQuoteRecords(ids).then(() => {
      message.success(t('报价单合并成功')+'！')
      setSelectKeys([])
    }).finally(() => {
      setLoading(false)
      // setNeedReload(!needReload)
    })
  }

  // 下载报价单
  const handleDownload = (record) => {
    setDownload(true)

    http.get('/javaApi/front/export/quoteExcel', {params: {quoteId: record.id}, responseType: 'blob'})
      .then((res) => blobToExcel(res.data, '报价单-' + record.sn + '.xlsx'))
      .finally(() => setDownload(false))
  }

  const onSearch = (values) => {
    store.spq = values
    store.fetchQuoteRecords();
  }


  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          {/* <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
            <div className="step cur">{t('我的报价单')}</div>
            <div className="step ">{t('填写并核对订单信息')}</div>
            <div className="step ">{t('提交订单')}</div>
          </div> */}
        </div>


        <SearchForm onFinish={onSearch}>
          <SearchFormItem title={t('产品名称')} name='goodsName' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('报价单编号')} name='sn' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          {/* <SearchFormItem title={t('项目编号')} name='extra_sn' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          {/* <SearchFormItem title={t('中心号')} name='center_sn' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          <SearchFormItem title={t('货号')} name='factoryCode' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('品牌')} name='brand' span={8}>
            <Input placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
        </SearchForm>

        <div className="mainBox">

          {/* <div className="flex" style={{padding: '26px 0'}}>
            <Checkbox onChange={selectAll} style={{flex: 1, fontSize: 20, paddingLeft: 22}}>{t('全选')}</Checkbox>
            <Button onClick={handleMergeQuote} size="large" type='primary' loading={loading && !handleId}>{t('合并报价单')}</Button>
          </div> */}

          <List
            header=''
            footer=''
            dataSource={quoteRecords}
            split={false}
            pagination={false}
            loading={store.isFetching}
            renderItem={(item, index) => (
              <List.Item>

                <div style={{width: '100%'}}>

                  <div className={styles.innerTitle}>
                    <div>{t('报价单编号')}： {item.sn}</div>
                    {/*<div className={styles.badge}>{item.type * 1 === 1 ? '购' : '租'}</div>*/}
                    <div style={{"margin":"0 0.125rem"}}>
                      {/* {t(item.catalogName?.charAt(0)==='销'?'购':item.catalogName?.charAt(0))} */}
                    </div>

                    <div style={{flex: 1}}>{t('报价单总金额')}： <b style={{color: '#cc0000'}}>￥{item['totalPrice'].toFixed(2)}</b>
                    </div>
                    <div>{t('求购时间')}： {item['createdAt']}</div>
                    <Button size="small" type="primary" ghost style={{marginLeft: '0.0833rem'}} loading={download}
                            onClick={() => handleDownload(item)}>{t('下载报价单')}</Button>
                    {/* <Button size="small" type="primary" style={{marginLeft: 10}}
                            onClick={() => checkOrder(item)}
                            loading={loading && handleId === item.id}>{t('下单')}</Button> */}
                  </div>
                  <Table className={styles.table}
                         pagination={false}
                         bordered
                         rowClassName={makeRowClassName}
                        //  rowSelection={{
                        //    selectedRowKeys: lodash.get(selectKeys, index, []),
                        //    onChange: selectedRowKeys => onSelectChange(selectedRowKeys, index),
                        //  }}
                         rowKey='id'
                         dataSource={item.quoteItems}
                         columns={columns}/>

                </div>

              </List.Item>
            )}
          />

          <Modal
            title={t('下单')}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <div className='flex'>
              <span style={{width: '0.3125rem'}}>{t('PO号')}：</span>
              <Input placeholder={t('请输入')} onChange={e => setPoId(e.target.value)}/>
            </div>
          </Modal>
          <div className="pagination_container">
              <Pagination
                showSizeChanger={true}
                showLessItems={true}
                current={store.quotePage}
                pageSize={store.quotePageSize}
                total={store.quotePageTotal}
                showTotal={total => `共 ${total} 条`}
                pageSizeOptions={['10', '20', '50', '100']}
                onChange={store.quotePageChange}
            />
            </div>


        </div>


      </div>

    </React.Fragment>
  )
})
